import React from 'react';
import {Input, message, Icon, notification, Table, Tooltip } from "antd";
import BaseComponent from "../../../../base/BaseComponent";
import {uuid} from "../../../../utils";
import {Scrollbars} from "react-custom-scrollbars";
import {HEADER_HEIGHT} from "../../../../constants";
const { Search } = Input;
class PathConfig extends BaseComponent {

    notificationId = uuid();

    state = {
        dataSource:[]
    };

    componentDidMount() {
        this.loadData();
    }
    componentWillUnmount(){
        notification.destroy()
    }

   loadData = (quStr)=>{
        this.request({
            url: "/cm-sites-dispatch-product/pathConfig/list",
            body:quStr?{quStr}:{},
            method:'POST',
            contentType: "json",
            callBack:(data)=>{
                this.setState({dataSource:data},()=>{
                    // console.log(this.state.dataSource)
                });
            }
        })
    };

    columns = [
    {
        title: "数据来源",
        dataIndex: "codeName",
        width: 300,
        ellipsis: true,
        render:(codeName)=><Tooltip placement={"top"} title={codeName}>{codeName}</Tooltip>
    },{
        title: "文件类型",
        dataIndex: "resourceTypeName",
        width: 200,
        ellipsis: true,
        render:(resourceTypeName)=><Tooltip placement={"top"} title={resourceTypeName}>{resourceTypeName}</Tooltip>
    },{
        title: "资源存储路径",
        dataIndex: "path",
        ellipsis: true,
        render:(path, record)=>{
            if(record.editStatus){
                return <Input defaultValue={path} ref={dom=>record.dom = dom} />;
            }
            return path;
        }
    },{
        title: "操作",
        dataIndex: "id",
        width: 200,
        render:(id, record)=>{
            let newSecondSelectColor =this.sysConfigGetValueByKey("newSecondSelectColor", "#0050B3")
            if(record.editStatus){
                return <div><Button style={{color:newSecondSelectColor}} onClick={()=>{this.changeRecordEditStatus(record)}}>取消</Button>
                    <Button
                        style={{marginLeft:10,color:newSecondSelectColor}}
                        onClick={()=>{
                            if(record && record.dom){
                                record.path = record.dom.state.value;
                                this.updatePath({...record, dom:""}, ()=> {
                                    this.changeRecordEditStatus(record)
                                })
                            }
                        }}
                    >保存</Button></div>
            }
            return <Button style={{color:newSecondSelectColor}} onClick={()=>{this.changeRecordEditStatus(record)}}>编辑</Button>
        }
    }];

    changeRecordEditStatus = (record)=>{
        record.editStatus = !record.editStatus;
        this.setState({});
    };

    updatePath = (body, callBack)=>{
        let url = "/cm-sites-dispatch-product/pathConfig/updatePathById";
        this.request({
            url, contentType:"json", method: "post", body, callBack
        })
    };

    render() {
       
        let height = window.innerHeight - HEADER_HEIGHT - 127;
        let componentHeight = window.innerHeight-HEADER_HEIGHT-32;
        return (
            <div id={`pathConfig${this.notificationId}`} style={{background: '#ffffff',
                padding: '24px 15px',
                margin: "15px 0 15px 15px",
                height: componentHeight,
                position: 'relative',
                borderRadius:5}}>
                <table style={{marginBottom: 24}} cellPadding={0} cellSpacing={0} border={0} width={"100%"}><tbody><tr>
                    <td><Search
                        placeholder={"请输入关键字"}
                        allowClear={true}
                        onSearch={(text)=>{
                            this.loadData(text);
                        }}
                        style={{ width: 300 }}
                    /></td>
                    <td width={100} align={"right"} style={{cursor:"pointer",paddingRight:5}}
                        onClick={()=>{
                            if(this.sysConfig&&this.sysConfig.text){
                                let description;
                                if(this.sysConfig.text instanceof Array){
                                    description = <div >{
                                        this.sysConfig.text.map((item,index)=><p style={{marginBottom:5,color:'#000000 65%',}} key={index}>{item}</p>)
                                    }
                                    </div>;
                                }else{
                                    description = this.sysConfig.text;
                                }
                                notification.open({
                                    message: this.sysConfig.title?this.sysConfig.title:"资源路径配置说明",
                                    description,
                                    className:'exclamation',
                                    key : this.notificationId,
                                    style: {
                                        maxWidth: 600
                                    },
                                });
                            }
                        }}
                    >
                        <style>{`
                         .exclamation .ant-notification-notice-message{border-bottom: 1px solid #F0F0F0;width:100%;padding: 0px 0px 15px 0px}
                         .exclamation{padding: 10px 15px}
                          .exclamation .ant-notification-notice-close{top: 12px; }
                         `}</style>
                       
                        <Icon type={"info-circle"} style={{marginRight: 5}} />说明</td>

                </tr></tbody></table>
                <Scrollbars
                    style={{height: height + 'px'}}
                    // autoHeight
                    // autoHeightMax={document.body.clientHeight - HEADER_HEIGHT - 130}
                >
                    <Table
                           columns={this.columns}
                           dataSource={this.state.dataSource}
                           pagination={false}
                           rowClassName={`cm-table-body-row${this.notificationId}`}
                    />
                </Scrollbars>
                <style>{`
                    #pathConfig${this.notificationId} .cm-table-body-row${this.notificationId} {
                        height:70px
                    }
                    #pathConfig${this.notificationId} .cm-table-body-row${this.notificationId}:nth-child(2n) {
                        background-color: rgba(245, 248, 252, 1);
                    }
                `}</style>
            </div>
        );
    }

}

class Button extends React.Component{

    static defaultProps = {
        style:{},
        onClick: ()=>{}
    };

    render() {
        return <span onClick={()=>this.props.onClick()} style={{color:"#1890ff", cursor:"pointer", ...this.props.style}}>{React.Children.map(this.props.children, item=>{
            return item;
        })}</span>
    }

}

export default PathConfig;